import { CART_PATH, ORDER_PATH, ADDRESS_PATH, GIFT_PATH, MYPAGE_PATH, INQUIRY_PATH, PAYMENT_GIFT_PATH } from '../../shared/constant';

export const isAllowedUrl = (pathname: string) => {
  const NOT_ALLOWED_URL = [
    ORDER_PATH.order.uri,
    ORDER_PATH.success.uri,
    ORDER_PATH.fail.uri,
    ORDER_PATH.cancel.uri,
    PAYMENT_GIFT_PATH.success.uri,
    PAYMENT_GIFT_PATH.fail.uri,
    PAYMENT_GIFT_PATH.cancel.uri,
    CART_PATH.counter.uri,
    CART_PATH.cart.uri,
    ADDRESS_PATH.address.uri,
    ADDRESS_PATH.add.uri,
    ADDRESS_PATH.result.uri,
    ADDRESS_PATH.update.uri,
    GIFT_PATH.gift.uri,
    MYPAGE_PATH.inquiry.uri,
    INQUIRY_PATH.inquiry.uri,
  ];

  return !NOT_ALLOWED_URL.includes(pathname);
};
